import React from "react";
import { Link, useLocation } from "react-router-dom";
import { media } from "styled-bootstrap-grid";
import styled from "styled-components";

import SocialMedia from "./../social-media";
import { Buttons } from "./../button";
import Container from "../container";


// footer top

const FooterTop = styled(Container)`
	display: flex;
	flex-direction: column;
	margin: 2rem auto 2rem auto;
	${media.sm`
		margin: 3rem auto 3rem auto;
  `}
  ${media.md`
		margin: 4rem auto 4rem auto;
  `}
  ${media.lg`
		display: flex;
		flex-direction: row;
		justify-content: space-between;
  `}
	h2 {
    font-size: 32px;
    padding-bottom: 32px;
  }
  p {
    font-size: 16px;
  }
`;

const FooterTopSide = styled.div`
  margin-bottom: 48px;
  ${media.lg`
		margin-bottom: 0px;
  `}
`;

const FooterTopBottom = styled.div`
  display: flex;
	flex-direction: column;
  p {
    line-height: 1.8;
  }
  ${media.sm`
		flex-direction: row;
	`}
`;

const FooterTopBottomText = styled.p`
  margin: 0 0 20px 0;
  ${media.sm`
		margin: 0 30px 0 0;
	`}
	${media.md`
		margin: 0 60px 0 0;
	`}
	${media.lg`
		margin: 0 30px 0 0;
	`}
  ${media.xl`
		margin: 0 40px 0 0;
	`}
	a {
    color: #000;
    display: block;
    text-decoration: none;
    line-height: 1.8;
    &:hover {
      text-decoration: underline;
    }
  }
`;


// footer bottom
const FooterBottom = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
	margin-bottom: ${props => props.homePage ? '64px' : 0};
  padding: 2rem 2rem;
	background-color: ${props => props.homePage ? 'white' : props.theme.color.grey};
  ${media.lg`
		flex-direction: row;
	`}
`;

const ParagraphFooter = styled.p`
  margin-bottom: 24px;
  ${media.lg`
		margin-bottom: 0px;
	`}
`;

const FooterLinks = styled.div`
  margin-top: 24px;
  ${media.lg`
		margin-top: 0px;
	`}
`;

const StyledLink = styled(Link)`
  color: #000;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const Footer = () => {
  return (
		<>
			{
				(location.pathname === '/ueber-uns' || location.pathname === '/') &&
				<FooterTop>
					<FooterTopSide>
						<h2>
							Download <br /> Jahresbericht 2020 <br /> Baden-Württemberg
							Stiftung
						</h2>
						<Buttons />
					</FooterTopSide>
					<FooterTopSide>
						<h2>Kontakt</h2>
						<FooterTopBottom>
							<FooterTopBottomText>
								Baden-Württemberg Stiftung gGmbH
								<br />
								Nadia Lindemann
								<br />
								<a href={"mailto:lindemann@bwstiftung.de"}>lindemann@bwstiftung.de</a>
							</FooterTopBottomText>
							<p>
								+49 (0)711 / 24 84 76 – 73
								<br />
								Kriegsbergstraße 42
								<br />
								70174 Stuttgart
							</p>
						</FooterTopBottom>
					</FooterTopSide>
				</FooterTop>
			}
			<FooterBottom homePage={location.pathname === '/'}>
				<ParagraphFooter>
					<StyledLink
						to={{ pathname: `https://www.bwstiftung.de/de/` }}
						target="_blank"
					>
						© Baden-Württemberg Stiftung gGmbH
					</StyledLink>
				</ParagraphFooter>
				<SocialMedia />
				<FooterLinks>
					<StyledLink to={`/impressum`}>Impressum</StyledLink> |{" "}
					<StyledLink to={`/datenschutz`}>Datenschutz</StyledLink>
				</FooterLinks>
			</FooterBottom>
		</>
  );
};

export default Footer;